export default {
  en: {
    currencyFormat: {
      style: 'currency',
      currency: 'EUR',
    },
  },
  es: {
    currencyFormat: {
      style: 'currency',
      currency: 'EUR',
    },
  },
  ua: {
    currencyFormat: {
      style: 'currency',
      currency: 'EUR',
    },
  },
  pl: {
    currencyFormat: {
      style: 'currency',
      currency: 'PLN',
    },
  },
};
